import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export default function groupInstructionReducer(state = initialstate.groupInstructions, action) {
	switch (action.type) {
		case types.GET_GROUP_COMPONENTS_BY_COMPONENTID:
			if (action.response) {
				return action.response;
			}

			return state;
		default:
			return state;
	}
}
